// components/FullscreenLoader.tsx
import { Flex, Spinner } from '@chakra-ui/react'

export const AppLoadingIndicator = () => (
  <Flex align="center" justify="center" h="100vh">
    <Spinner size="xl" />
  </Flex>
)
